/**
 * 问卷入口横幅用到的 SVG 图标（来自 Figma 设计稿导出，已转为受控组件）
 */

import React from 'react'

/** 图片识别图标 · 相片 + 星芒，入口横幅左侧 */
export const PhotoRecognitionIcon: React.FC<{ size?: number }> = ({
  size = 15
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12.3 12.3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M10.7625 5.89375V3.5875C10.7625 3.31565 10.6545 3.05494 10.4623 2.86272C10.2701 2.67049 10.0093 2.5625 9.7375 2.5625H2.5625C2.29065 2.5625 2.02994 2.67049 1.83772 2.86272C1.64549 3.05494 1.5375 3.31565 1.5375 3.5875V8.7125C1.5375 8.98435 1.64549 9.24506 1.83772 9.43728C2.02994 9.62951 2.29065 9.7375 2.5625 9.7375H6.15"
      stroke="#6366F1"
      strokeWidth="0.9225"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.35625 5.8425C4.75251 5.8425 5.07375 5.52126 5.07375 5.125C5.07375 4.72874 4.75251 4.4075 4.35625 4.4075C3.95999 4.4075 3.63875 4.72874 3.63875 5.125C3.63875 5.52126 3.95999 5.8425 4.35625 5.8425Z"
      stroke="#6366F1"
      strokeWidth="0.9225"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5375 8.2L3.5875 6.15L5.125 7.6875"
      stroke="#6366F1"
      strokeWidth="0.9225"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.225 7.43125L9.68625 8.66125L10.9162 9.1225L9.68625 9.58375L9.225 10.8138L8.76375 9.58375L7.53375 9.1225L8.76375 8.66125L9.225 7.43125Z"
      fill="#6366F1"
    />
  </svg>
)

/** 向右箭头 · 入口横幅右侧 */
export const ArrowRightIcon: React.FC<{ size?: number }> = ({ size = 13 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10.66 10.66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M2.22084 5.33H8.43917M5.33001 8.43917L8.43917 5.33L5.33001 2.22083"
      stroke="#86909C"
      strokeWidth="0.7995"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
